import { render, staticRenderFns } from "./web-page.vue?vue&type=template&id=619db817&scoped=true"
import script from "./web-page.vue?vue&type=script&lang=js"
export * from "./web-page.vue?vue&type=script&lang=js"
import style0 from "./web-page.vue?vue&type=style&index=0&id=619db817&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619db817",
  null
  
)

export default component.exports